<template>
	<footer class="site-footer">
		<div class="footer-main">
			<div class="footer-brand">
				<Brand inverse />
				<p class="footer-about">
					Pay rent, fees, deposits and everyday services with your card, settled straight to the recipient's bank account. India's first card based payment solution, since 2014.
				</p>
			</div>
			<nav class="footer-links" aria-label="Company links">
				<h2>Company</h2>
				<router-link v-for="link in companyLinks" :key="link.href" :to="link.href">{{ link.label }}</router-link>
			</nav>
			<nav class="footer-links" aria-label="Resource links">
				<h2>Resources</h2>
				<router-link v-for="link in resourceLinks" :key="link.href" :to="link.href">{{ link.label }}</router-link>
			</nav>
			<div class="footer-links footer-contact">
				<h2>Get in touch</h2>
				<a href="mailto:121@paydeck.in" class="footer-mail"><Mail :size="15" :stroke-width="2.25" aria-hidden="true" />121@paydeck.in</a>
				<span>Monday to Friday, 9 AM to 6 PM IST</span>
				<a href="https://www.linkedin.com/company/paydeck%E2%84%A2" target="_blank" rel="noopener noreferrer">LinkedIn</a>
				<a href="https://twitter.com/paydeck" target="_blank" rel="noopener noreferrer">X (Twitter)</a>
			</div>
		</div>
		<p class="footer-entity">
			Paydeck Services in India are provided by <strong>Paydeck Technologies Private Limited</strong> (CIN U74999WB2018PTC225880).
		</p>
		<div class="footer-bottom">
			<span>© 2026 Paydeck. All rights reserved.</span>
			<a class="footer-back" href="#top">Back to top ↑</a>
		</div>
	</footer>
</template>

<script setup>
import { Mail } from "lucide-vue-next";
import Brand from "./Brand.vue";
import { companyLinks, resourceLinks } from "@/content/site";
</script>
